(function () {
  if (window.__lasHome) return;
  window.__lasHome = true;

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.las-tab');
    if (tab) {
      var root = tab.closest('[data-las-tabs]');
      root.querySelectorAll('.las-tab').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      root.querySelectorAll('.las-panel').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      return;
    }
    var arrow = e.target.closest('[data-las-dir]');
    if (arrow) {
      var slider = arrow.closest('.las-slider');
      var track = slider.querySelector('.las-slider__track');
      track.scrollBy({ left: track.clientWidth * Number(arrow.dataset.lasDir), behavior: 'smooth' });
      return;
    }
    var toggle = e.target.closest('.las-seo__toggle');
    if (toggle) {
      var seo = toggle.closest('.las-seo');
      var open = seo.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('span').textContent = open ? toggle.dataset.less : toggle.dataset.more;
    }
  });

  function bindCounters() {
    document.querySelectorAll('.las-slider').forEach(function (slider) {
      if (slider.dataset.bound) return;
      slider.dataset.bound = '1';
      var track = slider.querySelector('.las-slider__track');
      var count = slider.querySelector('[data-las-current]');
      if (!track || !count) return;
      track.addEventListener('scroll', function () {
        count.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
      }, { passive: true });
    });
  }
  bindCounters();
  document.addEventListener('DOMContentLoaded', bindCounters);
  document.addEventListener('shopify:section:load', bindCounters);
})();
